const ConsentPreferenceAction = Object.freeze({
  0: 'ConsentAuditLog_Action_Created',
  1: 'ConsentAuditLog_Action_Updated',
  2: 'ConsentAuditLog_Action_Deleted'
})

const ConsentPreferenceActionValue = Object.freeze({
  CREATE: 0,
  UPDATE: 1,
  DELETE: 2
})

const ConsentPreferenceType = Object.freeze({
  0: 'ConsentAuditLog_Type_Channel',
  1: 'ConsentAuditLog_Type_Preference'
})

export {
  ConsentPreferenceAction,
  ConsentPreferenceActionValue,
  ConsentPreferenceType
}



// WEBPACK FOOTER //
// ./src/modules/consent-manager/enum/ConsentAuditLogEnums.js